<template>
  <v-container fluid class="claim-page">
    <!-- Alert -->
    <AAlertBanner :messages="alertError" hide-title />

    <!-- Confirmation Dialog -->
    <v-dialog v-model="claimApprovedDialog" max-width="460" content-class="claim-confirm-dialog">
      <div class="claim-confirm-card">
        <h3 class="claim-confirm-card__title">Claim Approved from HRDC</h3>
        <p class="claim-confirm-card__message">Please confirm that you wish to Approve Claim From HRDC</p>
        <div class="claim-confirm-card__actions">
          <button
            class="claim-confirm-card__btn claim-confirm-card__btn--cancel"
            @click="claimApprovedDialog = false"
          >
            Cancel
          </button>
          <button
            class="claim-confirm-card__btn claim-confirm-card__btn--confirm"
            @click="modalClaimApprove()"
          >
            Submit
          </button>
        </div>
      </div>
    </v-dialog>

    <!-- Header -->
    <div class="claim-header">
      <div class="claim-header__top">

        <div v-if="!loadingDialog" class="claim-header__info">
          <h1 class="claim-header__title">
            {{ model.add.name }}
          </h1>
        </div>

        <div class="claim-header__actions">
          <span v-if="(isHrdcAdminRoles || isTaxpodAdminRoles) && !btnDisabled">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <button
                  class="hero-action-btn hero-action-btn--green"
                  :disabled="apiSubmit.isLoading"
                  @click="claimApprovedDialog = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon size="18">mdi-check-circle-outline</v-icon>
                </button>
              </template>
              <span>Submit</span>
            </v-tooltip>
          </span>
        </div>
      </div>
    </div>

    <!-- Claim Details Section -->
    <div class="claim-sections">
      <div class="section-card">
        <div class="section-header">
          <v-icon color="white" small>mdi-file-document-check-outline</v-icon>
          <span class="section-header__title">Claim Approval Details</span>
        </div>
        <div class="section-body">
          <!-- Claim ID -->
          <div class="form-row">
            <label class="form-label">Claim ID</label>
            <div class="form-field">
              <v-text-field
                dense
                filled
                disabled
                v-model="formData.claimId"
                :error-messages="errorField.claimId"
              ></v-text-field>
            </div>
          </div>

          <!-- taxPOD Subscription Date -->
          <div class="form-row" v-if="uploadClientInvoice">
            <label class="form-label">Subscription Date</label>
            <div class="form-field">
              <v-text-field
                dense
                filled
                disabled
                v-model="formData.subscriptionDate"
                :error-messages="errorField.subscriptionDate"
              ></v-text-field>
            </div>
          </div>

          <!-- Option to upload invoice or not -->
          <div class="form-row" v-if="uploadClientInvoice">
            <label class="form-label">Upload Client Invoice</label>
            <div class="form-field">
              <v-select
                :items="uploadInvoiceOption"
                filled
                dense
                v-model="formData.uploadInvoiceOption"
                :menu-props="{
                  bottom: true,
                  offsetY: true,
                }"
              ></v-select>
            </div>
          </div>

          <!-- taxPOD Invoice -->
          <div
            class="form-row"
            v-if="uploadClientInvoice && uploadInvoiceNowOrLater"
          >
            <label class="form-label">taxPOD Invoice</label>
            <div class="form-field">
              <div
                class="file-card"
                :class="formData.autoGeneratedTaxpodInvoice && formData.autoGeneratedTaxpodInvoice.length > 0 ? 'file-card--has-file' : 'file-card--empty'"
                @drop.prevent="addDropFile($event, 'autoGeneratedTaxpodInvoice')"
                @dragover.prevent
              >
                <div class="file-card__icon-wrap">
                  <div class="file-card__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__svg">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                    </svg>
                  </div>
                </div>
                <div class="file-card__info">
                  <span class="file-card__name">{{ formData.autoGeneratedTaxpodInvoice && formData.autoGeneratedTaxpodInvoice.length > 0 ? formData.autoGeneratedTaxpodInvoice.map(f => f.name).join(', ') : 'No file selected' }}</span>
                  <span class="file-card__hint">PDF (multiple files supported)</span>
                </div>
                <div class="file-card__actions">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <label class="file-card__btn" v-on="on">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" /></svg>
                        <input type="file" class="file-card__hidden" accept=".pdf" multiple @change="handleTaxpodInvoiceFileChange($event)" />
                      </label>
                    </template>
                    <span>Upload</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <button class="file-card__btn" v-on="on" @click="previewAttachment('autoGeneratedTaxpodInvoice')">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="file-card__btn-icon"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" /></svg>
                      </button>
                    </template>
                    <span>Preview</span>
                  </v-tooltip>
                </div>
              </div>
              <div v-if="errorField.autoGeneratedTaxpodInvoice" class="file-card__error">
                {{ Array.isArray(errorField.autoGeneratedTaxpodInvoice) ? errorField.autoGeneratedTaxpodInvoice.join(', ') : errorField.autoGeneratedTaxpodInvoice }}
              </div>
            </div>
          </div>

          <!-- Generate CN Request -->
          <div class="form-row" v-if="uploadClientInvoice">
            <label class="form-label">Generate CN Request</label>
            <div class="form-field">
              <v-select
                :items="generateCnOption"
                filled
                dense
                v-model="formData.generateCnOption"
                :menu-props="{
                  bottom: true,
                  offsetY: true,
                }"
                @change="changeGenerateCnOption()"
              ></v-select>
            </div>
          </div>

          <!-- Claim Approved Date -->
          <div class="form-row">
            <label class="form-label">Claim Approved Date</label>
            <div class="form-field">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div class="rv-datepicker__trigger" v-bind="attrs" v-on="on">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="rv-datepicker__icon">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
                    </svg>
                    <span v-if="formData.claimApprovedDate" class="rv-datepicker__text">{{ formData.claimApprovedDate }}</span>
                    <span v-else class="rv-datepicker__placeholder">Select date (YYYY-MM-DD)</span>
                  </div>
                </template>
                <v-date-picker
                  v-model="formData.claimApprovedDate"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(date)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
          </div>
        </div>
      </div>

      <!-- Credit Note Section -->
      <div class="section-card" v-if="isSpecialCnApplied">
        <div class="section-header section-header--green">
          <v-icon color="white" small>mdi-receipt-text-outline</v-icon>
          <span class="section-header__title">Credit Note Details</span>
          <div class="section-header__action">
            <button
              class="section-edit-btn"
              @click="toggleGenerateSpecialCnModal(true)"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="14" height="14">
                <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
              </svg>
              Edit
            </button>
          </div>
        </div>
        <div class="section-body">
          <p class="cn-description">Credit Note will be generated based on below data:</p>
          <div
            class="cn-card"
            v-for="(item, key) of this.specialCnRowData"
            :key="key"
          >
            <div class="cn-card__badge">CN {{ key + 1 }}</div>
            <div class="cn-card__details">
              <div class="cn-detail-row">
                <span class="cn-detail-label">Client Inv No.</span>
                <span class="cn-detail-value">{{ item["clientInvNo"] }}</span>
              </div>
              <div class="cn-detail-row">
                <span class="cn-detail-label">HRDC Inv No.</span>
                <span class="cn-detail-value">{{ item["hrdcInvNo"] }}</span>
              </div>
              <div class="cn-detail-row">
                <span class="cn-detail-label">Amount</span>
                <span class="cn-detail-value cn-detail-value--amount">RM {{ item["cnAmount"] }}</span>
              </div>
              <div class="cn-detail-row">
                <span class="cn-detail-label">Description</span>
                <span class="cn-detail-value" v-html="item['cnDesc']"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <HrdcLoader :loadingDialog="loadingDialog"></HrdcLoader>

    <GenerateSpecialCn
      :generateSpecialCnModal="generateSpecialCnModal"
      :formData="formData"
      :errorField="errorField"
      @toggleGenerateSpecialCnModal="toggleGenerateSpecialCnModal"
      @saveGenerateSpecialCnInfoChild="saveGenerateSpecialCnInfo"
    ></GenerateSpecialCn>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import Api from "@/objects/api";
import Model from "@/objects/model";
import Service from "@/objects/service";
import hrdcFunction from "@/objects/hrdcFunction";
import HrdcData from "@/services/hrdc/objects/globalData";
import GenerateSpecialCn from "@/components/views/GenerateSpecialCn";

export default {
  mixins: [hrdcFunction],
  components: {
    GenerateSpecialCn,
  },
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,
    }),
    uploadClientInvoice() {
      if (this.formData.paymentChannel == 1) {
        return true;
      }
      return false;
    },
    uploadInvoiceNowOrLater() {
      if (this.formData.uploadInvoiceOption) {
        return true;
      }

      return false;
    },
    isSpecialCnApplied() {
      return this.specialCnRowData.length > 0;
    },
  },
  props: ["params"],
  data: () => ({
    apiGetApplicationSingleDetail: new Api(),
    apiSubmit: new Api(),
    apiGetApplicationDetails: new Api(),
    model: new Model(),
    service: new Service(),
    hrdcData: new HrdcData(),
    alertError: [],
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,
    formData: {
      applicationNo: null,
      claimId: null,
      subscriptionDate: null,
      autoGeneratedTaxpodInvoice: [],
      paymentChannel: null,
      claimApprovedDate: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      uploadInvoiceOption: true,
      generateCnOption: "NORMAL_CN",
      specialCnPax: null,
      hrdcInvoiceNo: null,
    },
    errorField: {
      applicationNo: null,
      claimId: null,
      subscriptionDate: null,
      autoGeneratedTaxpodInvoice: null,
      claimApprovedDate: null,
      specialCnPax: null,
      cnAmount: [],
      clientInvNo: [],
      cnDesc: [],
      hrdcInvNo: [],
    },
    loadingDialog: false,
    claimApprovedDialog: false,
    editMode: false,
    btnDisabled: false,
    uploadInvoiceOption: [
      {
        text: "Upload Now",
        value: true,
      },
      {
        text: "Upload Later",
        value: false,
      },
    ],
    generateSpecialCnModal: false,
    specialCnFields: {
      clientInvNo: "Client Inv No.",
      hrdcInvNo: "HRDC Inv No.",
      cnAmount: "CN Amount",
      cnDesc: "CN Description",
    },
    specialCnBool: false,
    specialCnRowData: [],
  }),
  watch: {
    "formData.specialCnPax"(newValue) {
      if (newValue > 3 || newValue <= 0) {
        this.$nextTick(() => {
          this.formData.specialCnPax = null;
        });
      }
    },
  },
  async created() {
    this.showLoadingDialog();
    this.formData.applicationNo = this.$route.query._ausk;
    this.model.getByKey(this.params.modelKey);
    if (this.model.serviceKey) this.service.set("key", this.model.serviceKey);

    // Assign apiDetails by mapping repository.
    const apiDetails = {
      apiSubmit: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/claim_approved/update-claim-approved`,
        method: "post",
      },
      apiGetApplicationDetails: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/application/get-application-details`,
        method: "post",
        params: {
          applicationUuid: this.$route.query._ausk,
        },
      },
      apiGetApplicationSingleDetail: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/application/get-single-application`,
        method: "post",
        params: {
          applicationUuid: this.$route.query._ausk,
        },
      },
    };

    for (const api in apiDetails) {
      if (apiDetails[api].url !== undefined) {
        this[api].setUrl(apiDetails[api].url);
      }
      if (apiDetails[api].method !== undefined) {
        this[api].setMethod(apiDetails[api].method);
      }
      if (apiDetails[api].params !== undefined) {
        this[api].setParams(apiDetails[api].params);
      }
    }

    this.apiGetApplicationDetails.setCallbackCompleted((response) => {
      try {
        if (response.status) {
          const { data } = response;
          this.formData.claimId = data[0].claimId;
          this.formData.paymentChannel = data[0].paymentChannel;

          let subscriptionStartDate = data[0].subscriptionStartDate;
          let subscriptionEndDate = data[0].subscriptionEndDate;
          let subscriptionPeriod = null;
          if (subscriptionStartDate && subscriptionEndDate) {
            subscriptionPeriod = `${subscriptionStartDate} - ${subscriptionEndDate}`;
          }

          this.formData.subscriptionDate = subscriptionPeriod;
          this.formData.hrdcInvoiceNo = data[0].manualInvoiceToHrdc;
        }

        if (this.editMode) {
          this.apiGetApplicationSingleDetail.setCallbackCompleted(
            (response) => {
              try {
                const { status, data } = response;
                if (status) {
                  const claimApprovedStageId =
                    this.hrdcData.stagePriority.claimApprovedFromHrdc;
                  this.formData.claimApprovedDate = moment(
                    data.ApplicationLog.find(
                      (obj) => obj.stageId == claimApprovedStageId
                    ).startDate
                  ).format("YYYY-MM-DD");

                  for (const item of data.ApplicationAttachment) {
                    // Get the extension of file.
                    const parts = item.fileUrl.split(".");
                    const extension = parts[parts.length - 1];

                    // Create a Blob object from the data
                    const blob = new Blob([new Uint8Array(item.dataArray)]);

                    let file = null;

                    switch (item.type) {
                      case "autoGeneratedTaxpodInvoice":
                        // Create the File object
                        file = new File([blob], item.fileName, {
                          type: `application/${extension}`,
                        });

                        this.formData.autoGeneratedTaxpodInvoice = file;
                        break;
                    }
                  }
                }

                this.hideLoadingDialog();
              } catch (err) {
                console.log(err);
              }
            }
          );
          this.apiGetApplicationSingleDetail.fetch();
        } else {
          this.hideLoadingDialog();
        }
      } catch (err) {
        console.log(err);
      }
    });
    this.apiGetApplicationDetails.fetch();

    this.stages = await this.hrdcData.allStages;
    const currentStageId =
      this.hrdcData.stageIndex[this.$store.state.hrdc.data.stageId];
    this.rolesAssignation(this.auth.roles);
    if (!this.isHrdcAdminRoles) {
      this.alertError.push("You are not allowed to perform this action!");
      this.btnDisabled = true;
    }

    this.checkFormAlreadyFilledGreater(
      currentStageId,
      this.hrdcData.stageSlug.submittedClaimToHrdc
    );

    this.checkFormNotYetFilledLesser(
      currentStageId,
      this.hrdcData.stageSlug.submittedClaimToHrdc
    );
  },
  methods: {
    handleTaxpodInvoiceFileChange($event) {
      const files = Array.from($event.target.files);
      for (const file of files) {
        this.formData.autoGeneratedTaxpodInvoice.push(file);
      }
    },
    addDropFile(e, key) {
      for (const file of e.dataTransfer.files) {
        if (!file.type.match("pdf.*")) {
          this.errorField[key] = "Please select pdf file format";
          return;
        }

        this.formData[key].push(file);
      }
    },
    clearErrorMsg() {
      for (let error in this.errorField) {
        if (Array.isArray(this.errorField[error])) {
          this.errorField[error] = [];
        } else {
          this.errorField[error] = null;
        }
      }
    },
    showErrorMessage(response) {
      for (const key in response.data) {
        this.errorField[key] = null;
        this.errorField[key] = response.data[key];
      }
    },
    modalClaimApprove() {
      this.claimApprovedDialog = !this.claimApprovedDialog;
      this.submit();
    },
    redirectBack() {
      let route = "HrdcApplication";
      if (this.params.backTo) {
        route = this.params.backTo;
      }

      this.$store.commit("assignDeveloperData", {
        paginationPageNo: this.$route.query.currentPageNo,
      });

      this.$router.push({
        name: route,
        params: {
          modelKey: this.model.key,
          backTo: "",
        },
        query: {
          viewId: this.$store.state.hrdc.data.viewId,
          _ausk: this.$route.query._ausk,
        },
      });
    },
    previewAttachment(fileType) {
      if (this.formData[fileType].length == 0) {
        this.$store.dispatch("showMessage", {
          message: "No Preview Available",
          messageType: "info",
        });
        return;
      }

      let url = null;
      let newWindow = null;
      for (const file of this.formData[fileType]) {
        switch (fileType) {
          default:
            url = URL.createObjectURL(file);
            newWindow = window.open(url, "_blank");
            break;
        }

        if (newWindow) {
          newWindow.onload = function () {
            // Revoke the object URL when the window is closed
            newWindow.addEventListener("beforeunload", function () {
              URL.revokeObjectURL(url);
            });
          };
        }
      }
    },
    changeGenerateCnOption() {
      if (this.formData.generateCnOption == "SPECIAL_CN") {
        this.toggleGenerateSpecialCnModal(true);
      } else {
        this.specialCnRowData = [];
      }
    },
    toggleGenerateSpecialCnModal(val) {
      this.generateSpecialCnModal = val;

      // Remove all Special CN Data if discarded.
      if (!val) {
        this.formData.specialCnPax = null;
        for (const item in this.specialCnFields) {
          this.formData[item] = {};
        }

        this.formData.generateCnOption = "NORMAL_CN";
        this.specialCnRowData = [];
      }
    },
    saveGenerateSpecialCnInfo(specialCnData) {
      // Check for CN pax.
      if (!specialCnData.specialCnPax.lazyValue) {
        this.$set(this.errorField, "specialCnPax", "CN Pax is required");
        return false;
      }

      // Reset CN Pax error message.
      this.$set(this.errorField, "specialCnPax", null);

      const cnAmount = {};
      const clientInvNo = {};
      const hrdcInvNo = {};
      const cnDesc = {};

      let isCnError = false;
      for (const item in this.specialCnFields) {
        for (let i = 0; i < this.formData.specialCnPax; i++) {
          this.$set(this.errorField[item], i, []);
          const cnData = specialCnData[item][i].lazyValue;
          if (!cnData) {
            this.$set(
              this.errorField[item],
              i,
              `${this.specialCnFields[item]} is required`
            );
            isCnError = true;
          }

          // Store special CN data into Form Data.
          cnAmount[i] = specialCnData["cnAmount"][i].lazyValue;
          clientInvNo[i] = specialCnData["clientInvNo"][i].lazyValue;
          hrdcInvNo[i] = specialCnData["hrdcInvNo"][i].lazyValue;
          cnDesc[i] = specialCnData["cnDesc"][i].lazyValue;
        }
      }

      if (isCnError) {
        return false;
      }

      this.specialCnRowData = [];

      for (let i = 0; i < this.formData.specialCnPax; i++) {
        this.specialCnRowData.push({
          clientInvNo: clientInvNo[i],
          hrdcInvNo: hrdcInvNo[i],
          cnAmount: cnAmount[i],
          cnDesc: cnDesc[i],
        });
      }

      // Close modal after saved.
      this.generateSpecialCnModal = false;
    },
    async submit() {
      this.showLoadingDialog();

      const fd = new FormData();
      fd.append("applicationUuid", this.formData.applicationNo);
      fd.append("claimApprovedDate", this.formData.claimApprovedDate);

      let fileCounter = 0;
      for (
        let i = 0;
        i < this.formData.autoGeneratedTaxpodInvoice.length;
        i++
      ) {
        fileCounter++;
        fd.append(
          `autoGeneratedTaxpodInvoice_${i}`,
          this.formData.autoGeneratedTaxpodInvoice[i]
        );
      }

      fd.append("paymentChannel", this.formData.paymentChannel);
      fd.append("referById", this.auth.uuid);
      fd.append("editMode", this.editMode);
      fd.append("uploadInvoiceOption", this.formData.uploadInvoiceOption);
      fd.append("fileCounter", fileCounter);
      fd.append("generateCnOption", this.formData.generateCnOption);
      fd.append("specialCnRowData", JSON.stringify(this.specialCnRowData));

      this.apiSubmit.setParams(fd);
      this.apiSubmit.setCallbackError(() => {
        this.hideLoadingDialog();
        this.$store.dispatch("showMessage", {
          message: "Something went wrong. Please try again later.",
          messageType: "error",
          timeout: 2000,
        });
      });
      this.apiSubmit.setCallbackCompleted((response) => {
        try {
          this.clearErrorMsg();
          this.hideLoadingDialog();
          if (!response.status) {
            this.showErrorMessage(response);
            this.$store.dispatch("showMessage", {
              message:
                response.message ?? "Please fill-in all the required fields",
              messageType: "error",
              timeout: 2000,
            });
          }

          if (response.status) {
            this.$store.commit("assignDeveloperData", {
              paginationPageNo: this.$route.query.currentPageNo,
            });

            this.$router.push({
              name: "HrdcApplication",
              query: {
                viewId: this.$store.state.hrdc.data.viewId,
              },
            });
            this.$store.dispatch("showMessage", {
              message: response.data,
              messageType: "success",
              timeout: 2000,
            });
          }
        } catch (err) {
          console.log(err);
        }
      });
      this.apiSubmit.fetch();
    },
  },
};
</script>

<style scoped>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .claim-page {
  background-color: var(--app-page);
}

.dark-mode .claim-header {
  background: var(--app-elevated);
}

.dark-mode .back-btn {
  background: var(--app-form-tile);
  border: 1px solid var(--app-border-strong);
}

.dark-mode .back-btn:hover {
  background: var(--app-form-tile-hover);
  border-color: var(--app-border-strong);
}

.dark-mode .hero-action-btn {
  background: var(--app-form-tile);
  color: var(--app-text-muted);
}

.dark-mode .hero-action-btn:hover {
  background: var(--app-form-tile-hover);
  color: var(--app-text);
}

.dark-mode .hero-action-btn--blue {
  background: var(--app-accent-soft);
}

.dark-mode .hero-action-btn--blue:hover {
  background: var(--app-accent-soft);
}

.dark-mode .hero-action-btn--green {
  background: var(--app-success-bg);
}

.dark-mode .hero-action-btn--green:hover {
  background: var(--app-success-bg);
}

.dark-mode .section-card {
  background: var(--app-elevated);
}

.dark-mode .section-body {
  background: var(--app-card);
}

.dark-mode .file-card {
  background: var(--app-form-tile);
  border: 1px solid var(--app-border);
}

.dark-mode .file-card:hover {
  background: var(--app-form-tile-hover);
}

.dark-mode .file-card__icon-wrap::after {
  border: 2px solid var(--app-card);
}

.dark-mode .file-card--has-file .file-card__icon-wrap::after {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke-width='3' stroke='var(--app-card)'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='m4.5 12.75 6 6 9-13.5'/%3E%3C/svg%3E");
}

.dark-mode .file-card--empty .file-card__icon-wrap::after {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke-width='3' stroke='var(--app-card)'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M6 18 18 6M6 6l12 12'/%3E%3C/svg%3E");
}

.dark-mode .file-card__name {
  color: var(--app-text);
}

.dark-mode .file-card__hint {
  color: var(--app-text-faint);
}

.dark-mode .file-card__btn {
  background: var(--app-form-tile);
  color: var(--app-text-muted);
}

.dark-mode .file-card__btn:hover {
  background: var(--app-form-tile-hover);
  color: var(--app-text);
}

.dark-mode .preview-btn {
  border: 1.5px solid var(--app-border-strong);
  background: var(--app-form-tile);
}

.dark-mode .preview-btn:hover {
  background: var(--app-accent-soft);
}

.dark-mode .cn-description {
  color: var(--app-text-muted);
}

.dark-mode .cn-card {
  background: var(--app-surface);
  border: 1px solid var(--app-border);
}

.dark-mode .cn-card:hover {
  border-color: var(--app-border-strong);
}

.dark-mode .cn-detail-label {
  color: var(--app-text-muted);
}

.dark-mode .cn-detail-value {
  color: var(--app-text);
}

.dark-mode .rv-datepicker__trigger {
  border: 1px solid var(--app-field-border);
  background: var(--app-field);
}

.dark-mode .rv-datepicker__trigger:hover {
  border-color: var(--app-field-border-hover);
}

.dark-mode .rv-datepicker__icon {
  color: var(--app-text-faint);
}

.dark-mode .rv-datepicker__text {
  color: var(--app-text);
}

.dark-mode .rv-datepicker__placeholder {
  color: var(--app-text-faint);
}

.dark-mode .form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot {
  background: var(--app-field) !important;
  border: 1.5px solid var(--app-field-border) !important;
}

.dark-mode .form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot:hover {
  border-color: var(--app-field-border-hover) !important;
}

.dark-mode .form-field >>> .v-input--is-disabled .v-input__slot {
  background: var(--app-field-disabled) !important;
  border: 1px dashed var(--app-field-disabled-border) !important;
}

.dark-mode .form-field >>> .v-input--is-disabled input,
.dark-mode .form-field >>> .v-input--is-disabled textarea,
.dark-mode .form-field >>> .v-input--is-disabled .v-select__selection {
  color: var(--app-text-faint) !important;
}

.dark-mode .form-field >>> .v-label {
  color: var(--app-text-muted);
}

.dark-mode .claim-confirm-card {
  background: var(--app-form-tile);
}

.dark-mode .claim-confirm-card__title {
  color: var(--app-text);
}

.dark-mode .claim-confirm-card__message {
  color: var(--app-text-muted);
}

.dark-mode .claim-confirm-card__btn--cancel {
  background: var(--app-form-tile);
  border: 1.5px solid var(--app-border-strong);
}

.dark-mode .claim-confirm-card__btn--cancel:hover {
  background: var(--app-form-tile-hover);
}

/* >>> end auto-dark <<< */

/* ============================================
   PAGE WRAPPER
   ============================================ */
.claim-page {
  background-color: #d8dce2;
  /* Fills main minus the breadcrumb and footer; a `100vh - 64px` guess only
     subtracts the app bar and overflows. See .layout-main__content. */
  flex: 1 0 auto;
  padding-top: 24px !important;
  padding-bottom: 60px !important;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  zoom: 1.1;
}

/* ============================================
   HEADER
   ============================================ */
.claim-header {
  background: #eaecef;
  border-radius: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  margin-bottom: 24px;
  overflow: hidden;
}

.claim-header__top {
  display: flex;
  align-items: center;
  padding: 24px 28px 16px;
}

.back-btn {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #d1d5db;
  cursor: pointer;
  margin-right: 16px;
  transition: all 0.2s ease;
}

.back-btn:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.claim-header__info {
  flex: 1;
  min-width: 0;
}

.claim-header__title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #3a3f47;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  letter-spacing: -0.2px;
}

.claim-header__actions {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: 16px;
}

/* ============================================
   HERO ACTION BUTTONS
   ============================================ */
.hero-action-btn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: none;
  background: #f1f5f9;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.hero-action-btn:hover {
  background: #e2e8f0;
  color: #334155;
  transform: translateY(-1px);
}

.hero-action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.hero-icon {
  width: 18px;
  height: 18px;
}

.hero-action-btn--blue {
  background: #eff6ff;
  color: #3b82f6;
}

.hero-action-btn--blue:hover {
  background: #dbeafe;
  color: #2563eb;
}

.hero-action-btn--green {
  background: #dcfce7;
  color: #16a34a;
}

.hero-action-btn--green:hover {
  background: #d1fae5;
  color: #059669;
}

/* ============================================
   SECTION CARDS
   ============================================ */
.claim-sections {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.section-card {
  background: #eaecef;
  border-radius: 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.section-card:hover {
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.06);
}

.section-header {
  background: linear-gradient(135deg, #0ea5e9, #38bdf8);
  padding: 13px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-header--green {
  background: linear-gradient(135deg, #10b981, #34d399);
}

.section-header__title {
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  flex: 1;
}

.section-header__action {
  margin-left: auto;
}

.section-edit-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  padding: 5px 12px;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 600;
  font-family: 'Lato', sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
}

.section-edit-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
}

.section-body {
  padding: 22px;
  background: #fff;
}

/* ============================================
   FORM ROWS & FIELDS
   ============================================ */
.form-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 12px;
}

.form-label {
  flex: 0 0 180px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #2d3239;
  line-height: 1.6;
  padding-top: 10px;
}

.form-field {
  flex: 1;
  min-width: 0;
}

.form-field--inline {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.form-field__file-wrapper {
  flex: 1;
  min-width: 0;
}

/* ============================================
   FILE CARD
   ============================================ */
.file-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #e2e4e8;
  transition: background 0.15s;
}

.file-card:hover {
  background: #f1f5f9;
}

.file-card__icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #f1e5e5;
  color: #ef4444;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.file-card__icon-wrap {
  position: relative;
  flex-shrink: 0;
}

.file-card__icon-wrap::after {
  content: '';
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid white;
  background-repeat: no-repeat;
}

.file-card--has-file .file-card__icon-wrap::after {
  background-color: #22c55e;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke-width='3' stroke='white'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='m4.5 12.75 6 6 9-13.5'/%3E%3C/svg%3E");
}

.file-card--empty .file-card__icon-wrap::after {
  background-color: #ef4444;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke-width='3' stroke='white'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M6 18 18 6M6 6l12 12'/%3E%3C/svg%3E");
}

.file-card__svg {
  width: 20px;
  height: 20px;
}

.file-card__info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.file-card__name {
  font-size: 0.82rem;
  font-weight: 500;
  color: #334155;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-card__hint {
  font-size: 0.7rem;
  color: #94a3b8;
}

.file-card__actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.file-card__btn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: none;
  background: #f1f5f9;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.file-card__btn:hover {
  background: #e2e8f0;
  color: #334155;
}

.file-card__btn-icon {
  width: 16px;
  height: 16px;
}

.file-card__hidden {
  display: none;
}

.file-card__error {
  color: #dc2626;
  font-size: 0.75rem;
  margin-top: 4px;
  padding-left: 4px;
}

/* ============================================
   PREVIEW BUTTON
   ============================================ */
.preview-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 10px;
  border: 1.5px solid #d1d5db;
  background: #fff;
  color: #3a3f47;
  font-size: 0.8rem;
  font-weight: 600;
  font-family: 'Lato', sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  flex-shrink: 0;
}

.preview-btn:hover {
  background: #f0f9ff;
  border-color: #0ea5e9;
  color: #0ea5e9;
}

/* ============================================
   CREDIT NOTE CARDS
   ============================================ */
.cn-description {
  font-size: 0.85rem;
  color: #64748b;
  margin: 0 0 16px;
  font-weight: 500;
}

.cn-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  transition: all 0.15s ease;
}

.cn-card:last-child {
  margin-bottom: 0;
}

.cn-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.cn-card__badge {
  display: inline-block;
  background: linear-gradient(135deg, #10b981, #34d399);
  color: #fff;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 3px 10px;
  border-radius: 6px;
  margin-bottom: 12px;
}

.cn-card__details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cn-detail-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.cn-detail-label {
  flex: 0 0 120px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #64748b;
}

.cn-detail-value {
  flex: 1;
  font-size: 0.85rem;
  font-weight: 500;
  color: #1e293b;
  word-break: break-word;
}

.cn-detail-value--amount {
  font-weight: 700;
  color: #059669;
}

/* ============================================
   DATEPICKER TRIGGER
   ============================================ */
.rv-datepicker__trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 42px;
  padding: 6px 12px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
}

.rv-datepicker__trigger:hover {
  border-color: #94a3b8;
}

.rv-datepicker__icon {
  width: 18px;
  height: 18px;
  color: #94a3b8;
  flex-shrink: 0;
}

.rv-datepicker__text {
  color: #1e293b;
  font-weight: 600;
}

.rv-datepicker__placeholder {
  color: #94a3b8;
}

/* ============================================
   VUETIFY INPUT OVERRIDES
   ============================================ */
.form-field >>> .v-input {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.form-field >>> .v-input__slot {
  border-radius: 10px !important;
  min-height: 40px !important;
}

.form-field >>> .v-text-field__details {
  margin-bottom: 0 !important;
  padding-top: 2px !important;
  min-height: 0 !important;
}

.form-field >>> .v-messages {
  min-height: 0 !important;
}

.form-field >>> .v-text-field--filled > .v-input__control > .v-input__slot {
  border-radius: 10px !important;
}

.form-field >>> .v-input--is-focused .v-input__slot {
  border-color: #56bde8 !important;
  box-shadow: 0 0 0 3px rgba(86, 189, 232, 0.12) !important;
}

.form-field >>> .v-input__slot::before,
.form-field >>> .v-input__slot::after {
  display: none !important;
}

/* Editable fields */
.form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot {
  background: #fff !important;
  border: 1.5px solid #d1d5db !important;
}

.form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot:hover {
  border-color: #94a3b8 !important;
}

/* Disabled fields */
.form-field >>> .v-input--is-disabled .v-input__slot {
  background: #f1f5f9 !important;
  border: 1px dashed #e2e8f0 !important;
  cursor: not-allowed !important;
}

.form-field >>> .v-input--is-disabled input,
.form-field >>> .v-input--is-disabled textarea,
.form-field >>> .v-input--is-disabled .v-select__selection {
  color: #94a3b8 !important;
}

.form-field >>> .v-text-field--filled:not(.v-input--is-focused) > .v-input__control > .v-input__slot::before {
  border: none !important;
}

.form-field >>> .v-text-field--filled > .v-input__control > .v-input__slot::after {
  border: none !important;
}

.form-field >>> .v-label {
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
  color: #64748b;
}

.form-field >>> .v-text-field input,
.form-field >>> .v-select__selection,
.form-field >>> .v-text-field textarea {
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  color: #1a1e24;
}

/* Error state */
.form-field >>> .v-input--has-state .v-input__slot {
  border-color: #f87171 !important;
}

.form-field >>> .v-text-field--filled:not(.v-input--is-disabled).v-input--has-state > .v-input__control > .v-input__slot {
  border-color: #ef4444 !important;
}

.form-field >>> .v-messages__message {
  font-family: 'Lato', sans-serif;
  font-size: 0.75rem;
  color: #ef4444;
}

/* ============================================
   CONFIRM DIALOG
   ============================================ */
.claim-confirm-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
}

.claim-confirm-card {
  background: #fff;
  border-radius: 20px;
  padding: 32px 32px 24px;
  text-align: center;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
}

.claim-confirm-card__title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 10px;
}

.claim-confirm-card__message {
  font-size: 0.9rem;
  color: #64748b;
  margin: 0 0 24px;
  line-height: 1.5;
}

.claim-confirm-card__actions {
  display: flex;
  gap: 12px;
}

.claim-confirm-card__btn {
  flex: 1;
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: 'Lato', sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
}

.claim-confirm-card__btn--cancel {
  background: #fff;
  color: #0ea5e9;
  border: 1.5px solid #d1d5db;
}

.claim-confirm-card__btn--cancel:hover {
  background: #f8fafc;
  border-color: #0ea5e9;
}

.claim-confirm-card__btn--confirm {
  background: #56bde8;
  color: #fff;
  border: none;
}

.claim-confirm-card__btn--confirm:hover {
  background: #3dadd8;
  box-shadow: 0 4px 12px rgba(86, 189, 232, 0.3);
}

/* ============================================
   VUETIFY OVERRIDES
   ============================================ */
.v-btn {
  opacity: 1 !important;
}

.v-messages__message {
  color: #ef4444;
}

/* ============================================
   MOBILE RESPONSIVE
   ============================================ */
@media (max-width: 599px) {
  .claim-page {
    padding: 12px 8px !important;
    zoom: 1;
  }

  .claim-header {
    border-radius: 14px;
    margin-bottom: 16px;
  }

  .claim-header__top {
    flex-wrap: wrap;
    padding: 16px 16px 12px;
  }

  .back-btn {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    margin-right: 12px;
  }

  .claim-header__title {
    font-size: 1.05rem;
    white-space: normal;
  }

  .claim-header__actions {
    width: 100%;
    margin-left: 0;
    margin-top: 10px;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 4px;
  }

  .hero-action-btn {
    width: 36px;
    height: 36px;
  }

  .claim-sections {
    gap: 14px;
  }

  .section-card {
    border-radius: 14px;
    max-width: 100%;
    overflow: hidden;
  }

  .section-header {
    padding: 12px 16px;
  }

  .section-header__title {
    font-size: 0.65rem;
    letter-spacing: 1.5px;
  }

  .section-body {
    padding: 14px;
    overflow: hidden;
    word-break: break-word;
  }

  .form-row {
    flex-direction: column;
    gap: 2px;
    align-items: stretch;
  }

  .form-label {
    flex: none;
    width: 100%;
    font-size: 0.72rem;
    padding-top: 0;
    margin-bottom: 2px;
  }

  .form-field {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }

  .form-field >>> .v-input {
    width: 100% !important;
  }

  .form-field >>> .v-input__control {
    width: 100% !important;
  }

  .form-field >>> .v-input__slot {
    width: 100% !important;
    box-sizing: border-box !important;
  }

  .form-field--inline {
    flex-direction: column;
    gap: 4px;
    width: 100%;
  }

  .preview-btn {
    width: 100%;
    justify-content: center;
  }

  .cn-detail-row {
    flex-direction: column;
    gap: 2px;
  }

  .cn-detail-label {
    flex: none;
  }

  .claim-confirm-card {
    padding: 24px 20px 20px;
  }

  .claim-confirm-card__title {
    font-size: 1.05rem;
  }

  .claim-page {
    overflow-x: hidden;
  }
}

/* Tablet breakpoint */
@media (min-width: 600px) and (max-width: 959px) {
  .claim-page {
    zoom: 1;
  }

  .claim-header__top {
    padding: 20px 20px 14px;
  }

  .claim-header__title {
    font-size: 1.15rem;
  }

  .claim-header__actions {
    flex-wrap: wrap;
    gap: 4px;
  }

  .section-body {
    padding: 18px;
  }

  .form-label {
    flex: 0 0 160px;
  }
}

/* ============================================
   DARK MODE
   ============================================ */
.dark-mode .claim-page {
  background-color: var(--app-page);
}

.dark-mode .claim-header {
  background: var(--app-card);
}

.dark-mode .claim-header__title {
  color: var(--app-text);
}

.dark-mode .back-btn {
  background: var(--app-form-tile);
  border-color: var(--app-form-tile-border);
}

.dark-mode .back-btn:hover {
  background: var(--app-form-tile-hover);
  border-color: var(--app-border-strong);
}

.dark-mode .section-card {
  background: var(--app-card);
}

.dark-mode .section-header {
  background: linear-gradient(135deg, var(--app-accent), var(--app-accent));
}

.dark-mode .section-header--green {
  background: linear-gradient(135deg, var(--app-success), var(--app-success));
}

.dark-mode .section-body {
  background: var(--app-card);
}

.dark-mode .form-label {
  color: var(--app-text-muted);
}

.dark-mode .form-field >>> .v-text-field--filled > .v-input__control > .v-input__slot {
  border-color: var(--app-field-border) !important;
}

.dark-mode .form-field >>> .v-text-field--filled > .v-input__control > .v-input__slot:hover {
  background: var(--app-field-hover) !important;
  border-color: var(--app-field-border-hover) !important;
}

.dark-mode .form-field >>> .v-input--is-focused .v-input__slot {
  border-color: var(--app-accent) !important;
  box-shadow: 0 0 0 3px var(--app-ring) !important;
}

.dark-mode .form-field >>> .v-text-field input,
.dark-mode .form-field >>> .v-select__selection,
.dark-mode .form-field >>> .v-text-field textarea {
  color: var(--app-text);
}

.dark-mode .form-field >>> .v-label {
  color: var(--app-field-placeholder);
}

.dark-mode .form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot {
  background: var(--app-field) !important;
  border: 1.5px solid var(--app-field-border) !important;
}

.dark-mode .form-field >>> .v-text-field--filled:not(.v-input--is-disabled) > .v-input__control > .v-input__slot:hover {
  border-color: var(--app-field-border-hover) !important;
}

.dark-mode .form-field >>> .v-input--is-disabled .v-input__slot {
  background: var(--app-field-disabled) !important;
  border: 1px dashed var(--app-field-disabled-border) !important;
}

.dark-mode .form-field >>> .v-input--is-disabled input,
.dark-mode .form-field >>> .v-input--is-disabled textarea,
.dark-mode .form-field >>> .v-input--is-disabled .v-select__selection {
  color: var(--app-text-faint) !important;
}

.dark-mode .hero-action-btn {
  background: var(--app-form-tile);
  color: var(--app-text-muted);
}

.dark-mode .hero-action-btn:hover {
  background: var(--app-form-tile-hover);
  color: var(--app-neutral-fg);
}

.dark-mode .hero-action-btn--blue {
  background: var(--app-accent-soft);
  color: var(--app-accent);
}

.dark-mode .hero-action-btn--blue:hover {
  background: var(--app-accent-soft);
  color: var(--app-accent-strong);
}

.dark-mode .preview-btn {
  background: var(--app-form-tile);
  border-color: var(--app-form-tile-border);
  color: var(--app-text-muted);
}

.dark-mode .preview-btn:hover {
  background: var(--app-form-tile-hover);
  border-color: var(--app-accent);
  color: var(--app-accent-strong);
}

.dark-mode .cn-card {
  background: var(--app-form-tile);
  border-color: var(--app-form-tile-border);
}

.dark-mode .cn-card:hover {
  border-color: var(--app-border);
}

.dark-mode .cn-description {
  color: var(--app-text-muted);
}

.dark-mode .cn-detail-label {
  color: var(--app-text-faint);
}

.dark-mode .cn-detail-value {
  color: var(--app-text);
}

.dark-mode .cn-detail-value--amount {
  color: var(--app-success-fg);
}

.dark-mode .rv-datepicker__trigger {
  background: var(--app-field);
  border-color: var(--app-field-border);
}

.dark-mode .rv-datepicker__trigger:hover {
  border-color: var(--app-field-border-hover);
}

.dark-mode .rv-datepicker__text {
  color: var(--app-text);
}

.dark-mode .rv-datepicker__placeholder {
  color: var(--app-text-faint);
}

.dark-mode .claim-confirm-card {
  background: var(--app-form-tile);
}

.dark-mode .claim-confirm-card__title {
  color: var(--app-text);
}

.dark-mode .claim-confirm-card__message {
  color: var(--app-text-muted);
}

.dark-mode .claim-confirm-card__btn--cancel {
  background: var(--app-form-tile);
  color: var(--app-accent-strong);
  border-color: var(--app-form-tile-border);
}

.dark-mode .claim-confirm-card__btn--cancel:hover {
  background: var(--app-form-tile-hover);
  border-color: var(--app-accent-strong);
}

.dark-mode .claim-confirm-card__btn--confirm {
  background: var(--app-accent);
}

.dark-mode .claim-confirm-card__btn--confirm:hover {
  background: var(--app-accent);
}

.dark-mode .section-edit-btn {
  background: var(--app-veil);
  border-color: var(--app-veil-border);
}

/* >>> dark companions: the light rules above pin these to a dark ink
   with !important, which on the dark field renders the text invisible
   rather than absent. Token references only. <<< */

.dark-mode .form-field >>> .v-text-field input,
.dark-mode .form-field >>> .v-select__selection,
.dark-mode .form-field >>> .v-text-field textarea {
  color: var(--app-text) !important;
}
</style>

<style>
/* The unscoped `.v-menu__content …` block that used to sit here is gone.
   It was global — unscoped CSS is injected once and never removed, so a rule
   written for THIS page's dropdown repainted every menu in the app (with
   !important, and with hard-coded light hex) for the rest of the session. That
   is what made the same v-select look different depending on which page you had
   visited. Menus are defined ONCE, in tokens, in src/plugins/theme-glass.css §3
   — panel, list, item radius, hover, active, typography and the state overlay.
   A page that genuinely needs its own menu styling should give that v-menu a
   `content-class` and key off it, the way .bdt-menu and .tb-view-menu do. */
</style>
